import { Button } from '@mui/material';
import React from 'react'
import { Link, useNavigate } from 'react-router-dom'
function ErrorPage() {
  const navigate = useNavigate();
  return (
    <div>
      <h1> Error Page </h1>
      <Link to={"/"}>
        <h2>Go to Sign in </h2> 
      </Link>
      <Button onClick={()=>{ navigate(-1)}}>
        Go back to last page
      </Button>
    </div>
  )
}

export default ErrorPage
